import i18next from "i18next";

export function templateBtnAlertaVagas(data, cargo, tipoPaginaID, localidadesSeparadas = ""){

    let btnAlertaVagas = "";

    if(data.exibirAlertaVagas){

        if(data.possuiAlertaVagas){
            btnAlertaVagas = `
            <button class="btn btn-outline-primary d-inline botao-alerta" id="botao-alerta" data-vaga-id="${tipoPaginaID}" data-alerta-id="${data.possuiAlertaVagas.ID}" data-profissao-id="${tipoPaginaID}" data-cargo="${cargo}" data-localidade="${localidadesSeparadas}">
            <i class="bi bi-gear"></i>  ${i18next.t('AlertaVagasBtnEditar')}
            </button>
            `;
        }

        else{
            btnAlertaVagas = `
            <button class="btn btn-outline-primary d-inline botao-alerta" id="botao-alerta" data-vaga-id="${tipoPaginaID}" data-profissao-id="${tipoPaginaID}" data-localidade="${localidadesSeparadas}" data-cargo="${cargo}">
            <i class="bi bi-bell"></i>  ${i18next.t('AlertaVagasBtnAtivar')}</button>
            `;
        }
    }

    return btnAlertaVagas;
}


export function templateCardAlertaVagas (data, cargo, tipoPaginaID, localidadesSeparadas = "", localidadesSeparadasVirgula = "") {
        
    let btnAlertaVagas = templateBtnAlertaVagas(data, cargo,tipoPaginaID,localidadesSeparadas);

    const template = `
        <div class="border-0 d-flex flex-row align-items-center justify-content-between" id="botao-wrapper-alerta">
            <div class="${data.exibirAlertaVagas ?  "col-8" : "col-12"}">
                <h5 class="m-0">
                    <b>${!data.exibirAlertaVagas ? i18next.t('AlertaVagasEntreCrieText') : (data.possuiAlertaVagas ? i18next.t('AlertaVagasEditarText') : i18next.t('AlertaVagasConfigurarAlertaText'))}</b> <b>${cargo}</b>
                </h5>

                <small>${cargo} ${i18next.t('AlertaVagasEm')} ${localidadesSeparadasVirgula}</small>
            </div>
            ${btnAlertaVagas}
        </div>
    `;

    return template;
}